import { DateTime } from 'luxon';
/* eslint-disable max-classes-per-file */

import { DATE_TIME_ISO_DATE_FORMAT } from '../shared/date-helper';

export abstract class JsonSerializable {
    public abstract toJson(): string;
}

export class DateWithoutTime extends JsonSerializable {
    public date: DateTime;

    constructor(date: DateTime) {
        super();
        this.date = date;
    }

    public toJson(): string {
        if (this.date === undefined) {
            return undefined;
        }
        return this.date.toFormat(DATE_TIME_ISO_DATE_FORMAT);
    }
}

export interface EnumNameAndValue {
    name: string;
    value: number;
}

export class EnumValues {
    public static getNamesAndValues(e: {}): EnumNameAndValue[] {
        return this.getNames(e).map(enumName => ({ name: enumName, value: e[enumName] as number }));
    }

    public static getNames(e: {}): string[] {
        return this.getObjectValues(e).filter(v => typeof v === 'string') as string[];
    }

    public static getValues(e: {}): number[] {
        return this.getObjectValues(e).filter(v => typeof v === 'number') as number[];
    }

    private static getObjectValues(e: {}): Array<number | string> {
        return Object.keys(e).map(k => e[k]);
    }
}

export interface SoftDeletable {
    isDeleted: boolean;
}

/* export class LogUtils {
    public static toString(value: MultiLingualString): string {
        return value === undefined ? 'undefined' : (value === null ? 'null' : 'de: ' + value.german
            + '; fr: ' + value.french + '; it: ' + value.italian + '; en: ' + value.english);
    }
} */
